import React from 'react';

const ImageQuestion = ({ data }) => <img src={data} alt="" />;

export default ImageQuestion;
